export const SITE_URL = 'https://pandabuy.cfd';
export const SITE_NAME = 'PandabuySpreadsheet';
export const SITE_LOGO = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg';

export const SITE_DESCRIPTION = 'The most complete curated pandabuyspreadsheet for discovering high-quality fashion at budget prices. Thousands of items, updated weekly.';

export const SITE_DESCRIPTION_LONG = 'The ultimate curated pandabuyspreadsheet for discovering high-quality fashion items, sneakers, streetwear, and budget gems — updated weekly.';